import { UIText2 } from '@cian/ui-kit';

import { FC } from 'react';

import { AnyAvailableWorkspaceIcon } from './internal/components/AnyAvailableWorkspaceIcon';
import { PersonalWorkspaceIcon } from './internal/components/PersonalWorkspaceIcon';

import styles from './Factoids.css';

type FactoidsProps = {
  title: string;
  iconType: 'anyAvailableWorkspace' | 'personalWorkspace' | null;
};

export const Factoids: FC<FactoidsProps> = props => {
  const { iconType, title } = props;

  switch (iconType) {
    case 'anyAvailableWorkspace':
      return (
        <div className={styles['container']}>
          <UIText2>{title}</UIText2>
          <AnyAvailableWorkspaceIcon />
        </div>
      );

    case 'personalWorkspace':
      return (
        <div className={styles['container']}>
          <UIText2>{title}</UIText2>
          <PersonalWorkspaceIcon />
        </div>
      );

    default:
      return <UIText2 color="gray60_100">{title}</UIText2>;
  }
};
